/* eslint-disable max-len */

export default {
    ru: [
        {
            id: Math.random(),
            name: `Кто может заключить договор страхования от COVID&#8209;19?`,
            announce: `Любой человек старше 1 года и моложе 65 лет на момент заключения договора`
        },
        {
            id: Math.random(),
            name: `Кто НЕ может заключить договор страхования от COVID&#8209;19?`,
            announce: `Недееспособные, ВИЧ-инфицированные и больные СПИДом люди`
        },
        {
            id: Math.random(),
            name: `Когда договор страхования от COVID&#8209;19 вступает в силу?`,
            announce: `Не ранее чем через 14 дней после дня уплаты единоразового страхового платежа 300 грн`
        },
        {
            id: Math.random(),
            name: `Какой срок действия договора?`,
            announce: `12 месяцев с момента выплаты страхового платежа`
        },
        {
            id: Math.random(),
            name: `Что нужно сделать при первых симптомах недомогания, чтобы получить страховую помощь?`,
            announce: `
                <ul>
                    <li>Если вам нужна консультативная помощь, связанная с подозрением на COVID&#8209;19, звоните в рабочие дни с 9:00 до 18:00 по телефону <a href="tel:0800507050"><b>0 800 50 70 50</b></a></li>
                    <li>Если вы заболели и самостоятельного обратились в медицинское учреждение в связи с COVID&#8209;19, то вам нужно в течение 24 часов обратиться в страховую компанию по телефону <a href="tel:0800507050"><b>0 800 50 70 50</b></a></li>
                </ul>
            `
        },
        {
            id: Math.random(),
            name: `Как происходит страховая выплата?`,
            announce: `Вы обращаетесь в клинику касательно заболевания у вас COVID&#8209;19, в течение суток сообщаете об этом в страховую. В течение 15 дней компания примет решение о страховой выплате, а еще в течение 15 дней вам выплатят сумму, которую вы потратили на диагностику и лечение`
        },
        {
            id: Math.random(),
            name: `Какое предоставляется обслуживание?`,
            announce: `В течение 12 месяцев вас сопровождает медицинский консьерж — врач-координатор, который посредством онлайн-консультации ответит на все ваши вопросы касательно COVID&#8209;19`
        }
    ],
    uk: [
        {
            id: Math.random(),
            name: `Хто може укласти договір страхування від COVID&#8209;19?`,
            announce: `Будь-яка людина старше 1 року і молодше 65 років на момент укладення договору`
        },
        {
            id: Math.random(),
            name: `Хто НЕ може укласти договір страхування від COVID&#8209;19?`,
            announce: `Недієздатні, ВІЛ-інфіковані та хворі на СНІД люди`
        },
        {
            id: Math.random(),
            name: `Коли договір страхування від COVID&#8209;19 вступає в силу?`,
            announce: `Не раніше ніж через 14 днів після дня сплати одноразового страхового платежу 300 грн`
        },
        {
            id: Math.random(),
            name: `Який термін дії договору?`,
            announce: `12 місяців з моменту виплати страхового платежу`
        },
        {
            id: Math.random(),
            name: `Що потрібно зробити при перших симптомах нездужання, щоб отримати страхову допомогу?`,
            announce: `
                <ul>
                    <li>Якщо вам потрібна консультативна допомога, пов'язана з підозрою на COVID&#8209;19, телефонуйте в робочі дні з 9:00 до 18:00 за телефоном <a href="tel:0800507050"><b>0 800 50 70 50</b></a></li>
                    <li>Якщо ви захворіли і самостійного звернулися до медичної установи у зв'язку з COVID&#8209;19, то вам потрібно протягом 24 годин звернутися в страхову компанію за телефоном <a href="tel:0800507050"><b>0 800 50 70 50</b></a></li>
                </ul>
            `
        },
        {
            id: Math.random(),
            name: `Як відбувається страхова виплата?`,
            announce: `Ви звертаєтеся в клініку щодо захворювання у вас COVID&#8209;19, протягом доби повідомляєте про це в страхову. Протягом 15 днів компанія прийме рішення про страхову виплату, а ще протягом 15 днів вам виплатять суму, яку ви витратили на діагностику і лікування`
        },
        {
            id: Math.random(),
            name: `Яке надається обслуговування?`,
            announce: `Протягом 12 місяців вас супроводжує медичний консьєрж — лікар-координатор, який за допомогою онлайн-консультації відповість на всі ваші запитання щодо COVID&#8209;19`
        }
    ]
};
